import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { resetButtons, setBackButtonVisible, setHomeButtonVisible, setReloadButtonVisible } from "../menu/menuSlice";
import { Page } from "../../Page";
import  styles  from "./Information.module.css"
import { useNavigate } from "react-router-dom";
import { isLive, isLocal, isMobile, versionNumber } from "../../AppSettings";
import { retrieveBackEndVersionNumberAsync, selectBackEndVersionNumber } from "../partyEvents/partyEventsSlice";
import { useAuth0 } from "@auth0/auth0-react";
import { BackButton } from "../menu/BackButton";

export function Information() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const backEndVersionNumber = useAppSelector(selectBackEndVersionNumber)
    const { isAuthenticated, getAccessTokenSilently, user } = useAuth0()
	useEffect(() => {
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
        dispatch(setHomeButtonVisible(true))
        dispatch(setReloadButtonVisible(true))
      }, [dispatch]);

      useEffect(() => {
        const getUserMetadata = async () => {
          if (isAuthenticated) {  
            try {
              const accessToken = await getAccessTokenSilently({ authorizationParams : {
            }})
                dispatch (retrieveBackEndVersionNumberAsync({token: accessToken}))
            } catch (error)  {
            }
          }
        };
      
        getUserMetadata();
        
      }, [dispatch, getAccessTokenSilently, isAuthenticated]);
    return (
        <Page>
          <div className={styles.bannerContainer}>
              <div>
                  <h2>PartyPlanner.</h2>
                     <h4>Organise, invite and celebrate in style.</h4>
              </div>
              <div className={styles.bannerButton}>
                  <BackButton/>
              </div>
          </div>
          <div className={styles.content}>
            <h1>Information</h1> <br></br>
            <h2> Backend version {backEndVersionNumber}</h2>
            <h2> Frontend version {versionNumber} </h2>
            <h2> Platform is {isLocal ? 'Local' :  isLive ? 'Live' : 'Development'} </h2>
            <h2> Built for {isMobile ? 'Mobile' : 'Web'}</h2>
            <br></br>
            <div >
                <button className={styles.buttons} onClick={ ()=> {
                    navigate('/Privacy')
                }}> Privacy </button>
                <br></br>
                <button className={styles.buttons} onClick={()=> {
                    navigate('/TermsAndConditions')
                }}> Terms and Conditions</button>
                <br></br>
                <button className={styles.buttons} onClick={()=> {
                    navigate('/Feedback')
                }}> FeedBack</button>
                <br></br>
                <button className={styles.buttons} onClick={()=> {
                    navigate('/DataDelete')
                }}> Deleting Your Data</button>
            </div>
          </div>
        </Page>

    )
}